import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MultipleSelectedCartComponent from '@components/MultipleSelectedCart/index';
import KioskConfirmatioPopUp from '@components/checksCommon/kioskConfirmationPopUp';
import cn from 'classnames';
import { reverse } from 'lodash';
import {
  APP_CONFIG,
  SUCCESS_MESSAGE,
} from '@constants';
import { LABEL } from '../../veriables';
import {
  removeItemFromCart,
  addChecks,
  deleteItm,
  pushCartItemsInfo,
  editCartItem,
  setSeat
} from '@reducers/orders';
import {
  updateChecksAfterResponse
} from '@reducers/storeChecks';
import { setNotification } from '@reducers/notification';
import { getObjectValue } from '@utility/utills';

const MultipleSelectedCart = (props) => {
  // Props Destructuring

  const { seat, deviceInfo, cart, addChecksToServer, removeItemFromCart, userInfo, deleteItm, setSeat, updateChecksAfterResponse, setNotification,
  pushCartItemsInfo, addChecks, editCartItem, handleRoute, deleteItem, checkOut } = props;

  // State Management

  const [subTotalAmount, setSubTotalAmount] = useState(0);
  const [isConfirmation, setIsConfirmation] = useState(false);
  const [cartItemDetails, setCartItemDetails] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const isDefaultMode = getObjectValue(() => (!deviceInfo.deviceGroup || [0].includes(deviceInfo.deviceGroup.startMode)), false);
  const isOrderPayMode = getObjectValue(() => [1].includes(deviceInfo.deviceGroup.startMode), false);
  const isPaymentMode = getObjectValue(() => [2].includes(deviceInfo.deviceGroup.startMode), false);
  const isOrderOnlyMode = getObjectValue(() => [3].includes(deviceInfo.deviceGroup.startMode), false);

  // React Hooks

  useEffect(() => {
    let subTotalAmt = 0;
    const items = seat && seat.orders && seat.orders[0] && seat.orders[0].items && seat.orders[0].items.length > 0 ? seat.orders[0].items.reduce((a, v) => {
      if (v.pending) {
        a.push({
          ...v,
          ...JSON.parse(v.orderJson),
          ...JSON.parse(JSON.parse(v.orderJson).modifierJson)
        });
        subTotalAmt += (JSON.parse(v.orderJson).quantity * JSON.parse(v.orderJson).price);
      }
      return a;
    }, []) : [];
    setSubTotalAmount(subTotalAmt);
    setCartItems(reverse(items));
  }, [seat]);

  // Methods

  const renderModifier = (modifiersObj) => (
    <div className={cn('pl-2')}>
      {modifiersObj && modifiersObj.map((modifier) => {
        if (modifier.modifiers && modifier.modifiers.length === 1 && getObjectValue(() => !modifier.modifiers[0].modifierGroupId, false)) {
          return (
            <div key={modifier.id} className="fs-14 fw-500">
              {modifier.modifiers[0].quantity > 1 && (<span className={cn('badge badge-warning ml-1 va-tt')}>{modifier.modifiers[0].quantity} &times;</span>)}
              {modifier.modifierName}
              {modifier.quantity > 1 && (<span className="badge badge-warning ml-1 va-tt">&times; {modifier.quantity}</span>)}
              {modifier.price ? (<small className="text-muted od-text-muted ml-1">{LABEL().CURRENCY_SYMBOL}{modifier.price.toFixed(2)}</small>) : ''}
            </div>
          );
        }
        return (
          <div key={modifier.id} className="fs-14 fw-500">
            {modifier.quantity > 1 && <span className={cn('badge badge-warning ml-1 va-tt')}>{modifier.quantity} &times;</span>}
            {modifier.modifierName}
            {modifier.price ? (<small className="text-muted od-text-muted ml-1">{LABEL().CURRENCY_SYMBOL}{modifier.price.toFixed(2)}</small>) : ''}
            {(modifier.note || modifier.comment) && <div className="pl-2">{modifier.note || modifier.comment}</div>}
            {modifier.modifiers && modifier.modifiers.length > 0 && (
              renderModifier(modifier.modifiers)
            )}
          </div>
        );
      })}
    </div>
  );

  const handleEdit = (data) => {
    const {
      menuTypeId,
      menuItemId,
      internalId,
      menuId, id
    } = data;
    if (cart.filter((e) => e.isProcessing).length > 0) {
      addChecksToServer(cart.filter((e) => e.isProcessing), data, 'edit');
    } else {
      props.navigate(`${APP_CONFIG.BASE_URL}/order-item/${menuTypeId}/${menuItemId}/${internalId}/1?menuId=${menuId}&checkItem=${id}&type=edit`, { replace: true });
    }
  };

  const onRemoveItemFromCart = (item) => {
    removeItemFromCart(item.internalId);
    if (item?.id) {
      const cartItem = cart.find((e) => e.internalId === item.internalId);
      const dataToSend = {
        checkHeaderId: seat.id,
        deviceId: deviceInfo.deviceId,
        employeeCard: userInfo.employeeCard,
        employeeId: userInfo.id,
        items: [{ checkOrderItemId: cartItem?.id }],
        storeId: deviceInfo.storeId
      };
      addChecksToServer(cart.filter((e) => e.isProcessing), [], 'pay').then(() => {
        deleteItm(dataToSend).then((res) => {
          setSeat(res);
          updateChecksAfterResponse(res);
        }).catch(() => {
          setNotification({
            type: 'danger',
            message: SUCCESS_MESSAGE.ITEM_DELETE_FAIL
          });
        });
      });
    } else {
      const checkHeaderObj = seat;
      checkHeaderObj.orders[0].items.filter((e) => JSON.parse(JSON.parse(e.orderJson).modifierJson).internalId !== item.internalId);
      checkHeaderObj.orders[0].items = checkHeaderObj.orders[0].items.filter((e) => JSON.parse(JSON.parse(e.orderJson).modifierJson).internalId !== item.internalId);
      updateChecksAfterResponse({ ...checkHeaderObj });
      setSeat({ ...checkHeaderObj });
    }
    pushCartItemsInfo();
  };

  const changeItemQuantity = (quantity, item) => {
    if (quantity > 0) {
      const cartItem = cart.find((e) => e.internalId === item.internalId);
      let cartItemToUpdate;
      if (cartItem?.id) {
        cartItemToUpdate = seat.orders[0] && seat.orders[0].items.find((e) => e.id === cartItem.id);
      }
      const modifierJson = cartItem?.id ? JSON.parse(JSON.parse(cartItemToUpdate.orderJson)?.modifierJson) : JSON.parse(cartItem?.modifierJson);
      const requestData = {
        ...modifierJson,
        quantity,
      };
      requestData.modifierJson = JSON.stringify(requestData);
      const itemInfoObj = {
        ...requestData,
        seatIds: [],
        modifiers: modifierJson.modifierObject,
        suppressNote: false,
        openPrice: null,
        ageRestricted: false,
        checkOrderItemId: cartItem?.id,
        isProcessing: !cartItem?.id && true
      };
      if (cartItem?.id) {
        const dataToSendToAdd = {
          storeId: deviceInfo.storeId,
          employeeId: userInfo.id,
          deviceId: deviceInfo.deviceId,
          checkHeaderId: seat.id,
          items: [itemInfoObj],
          employeeCard: userInfo.employeeCard,
          orderJson: JSON.stringify(itemInfoObj),
          longitude: '0',
          latitude: '0',
          geoLocation: '0'
        };
        addChecksToServer(cart.filter((e) => e.isProcessing), [], 'pay').then(() => {
          addChecks(dataToSendToAdd, 'update').then((res) => {
            setSeat(res);
            updateChecksAfterResponse(res);
            const cartData = {
              ...requestData,
              id: cartItem.id,
            };
            editCartItem(cartData);
          });
        });
      } else {
        const destructuredObj = {
          ageRestricted: false,
          checkItemId: '',
          id: '',
          orderJson: JSON.stringify(itemInfoObj),
          orderedAt: '',
          pending: true,
          isProcessing: true,
        };
        const checkHeaderObj = seat;
        checkHeaderObj.orders[0].items.filter((e) => JSON.parse(JSON.parse(e.orderJson).modifierJson).internalId !== itemInfoObj.internalId);
        checkHeaderObj.orders[0].items = checkHeaderObj.orders[0].items.filter((e) => JSON.parse(JSON.parse(e.orderJson).modifierJson).internalId !== itemInfoObj.internalId);
        checkHeaderObj.orders[0].items.push(destructuredObj);
        updateChecksAfterResponse();
        setSeat({ ...checkHeaderObj });
        editCartItem(itemInfoObj);
      }
    } else {
      onRemoveItemFromCart(item);
    }
  };

  const buttonList = [
    {
      key: 'delete all',
      displayName: LABEL().DELETE_ALL,
      isShow: (isDefaultMode || isOrderOnlyMode || isOrderPayMode || isPaymentMode)
    },
    {
      key: 'send all',
      displayName: LABEL().SEND_ALL,
      isShow: (isDefaultMode || isOrderOnlyMode)
    },
    {
      key: 'payment',
      displayName: LABEL().PAYMENT,
      isShow: isOrderPayMode
    },
  ];

  const handleButtonClick = (type, data) => {
    if (type === 'payment') {
      handleRoute();
    } else {
      setIsConfirmation(true);
      setCartItemDetails({ type, data });
    }
  };

  const onClose = (type) => {
    if (type === 'yes') {
      switch (cartItemDetails.type) {
        case 'delete all': deleteItem(cartItemDetails.data); break;
        case 'send all': checkOut(cartItemDetails.data); break;
        default:
          break;
      }
      setIsConfirmation(false);
    } else {
      setIsConfirmation(false);
    }
  };

  // HTML CSS Code

  return (
    <div className="w-100 h-100">
      <MultipleSelectedCartComponent
        cartItems={cartItems}
        currencySymbol={LABEL().CURRENCY_SYMBOL}
        renderModifier={renderModifier}
        handleEdit={handleEdit}
        changeItemQuantity={changeItemQuantity}
        onRemoveItemFromCart={onRemoveItemFromCart}
        subTotalAmount={subTotalAmount}
        buttonList={buttonList}
        handleButtonClick={handleButtonClick}
        menuItemsHashTable={menuItemsHashTable}
      />
      {isConfirmation && (
        <KioskConfirmatioPopUp
          isOpen={isConfirmation}
          onClose={onClose}
          type={cartItemDetails.type}
          data={cartItemDetails.data}
        />
      )}
    </div>
  );
};

// Redux part

const mapStateToProps = ({
  orders,
  oauth,
  checks,
  storeChecks
}) => ({
  deviceInfo: oauth.deviceInformation,
  userInfo: oauth.loggedInUserData,
  auth: oauth.authInfo,
  loading: orders.loading || checks.loading || storeChecks.loading,
  menuLoading: orders.menuLoading,
  cart: orders.cart,
  cartItemsInfo: orders.cartItemsInfo,
  seat: orders.seats,
  menuCard: orders.menuCardList,
  menusHashTable: orders.menusHashTable,
  menuItemsHashTable: orders.menuItemsHashTable,
  modifierGroupsHashTable: orders.modifierGroupsHashTable,
  modifierData: orders.modifierData,
  modifiersHashTable: orders.modifiersHashTable,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  removeItemFromCart,
  updateChecksAfterResponse,
  addChecks,
  setNotification,
  deleteItm,
  pushCartItemsInfo,
  editCartItem,
  setSeat
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MultipleSelectedCart);
